// extracted by mini-css-extract-plugin
export default {"Layout":"layout_Layout_kEyuG","Content":"layout_Content_qSb76"};